import React, { useEffect, useRef } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Nav, Collapse } from "reactstrap";
import { store } from 'store/index';
import avatar from "assets/img/faces/ayo-ogunseinde-2.jpg";
import API, { base } from "api.js";

function Sidebar(props) {
  const sidebarRef = useRef(null);           // This replaces this.sidebarRef = React.createRef()
  const location = useLocation();            // Replaces this.props.location

  // Replace component state with useState
  const [collapseStates, setCollapseStates] = React.useState(getCollapseStates(props.routes));
  const [openAvatar, setOpenAvatar] = React.useState(false);

  // Recreate getCollapseStates logic (same as before)
  function getCollapseStates(routes) {
    let initialState = {};
    routes.forEach((prop) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: getCollapseInitialState(prop.views),
          ...getCollapseStates(prop.views),
          ...initialState
        };
      }
    });
    return initialState;
  }

  function getCollapseInitialState(routes) {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (location.pathname.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  }

  // Toggle collapse
  const toggleCollapse = (stateName) => {
    setCollapseStates(prev => ({
      ...prev,
      [stateName]: !prev[stateName]
    }));
  };

  // Active route helper
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  // Create links (same logic)
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.redirect || prop.type === 2) return null;

      if (prop.collapse) {
        return (
          <li className={getCollapseInitialState(prop.views) ? "active" : ""} key={key}>
            <a
              href="#!"
              data-toggle="collapse"
              aria-expanded={collapseStates[prop.state]}
              onClick={(e) => {
                e.preventDefault();
                toggleCollapse(prop.state);
              }}
            >
              {prop.icon ? (
                <>
                  <i className={prop.icon} />
                  <p>{prop.name}<b className="caret" /></p>
                </>
              ) : (
                <>
                  <span className="sidebar-mini-icon">{prop.mini}</span>
                  <span className="sidebar-normal">{prop.name} <b className="caret" /></span>
                </>
              )}
            </a>
            <Collapse isOpen={collapseStates[prop.state]}>
              <ul className="nav">{createLinks(prop.views)}</ul>
            </Collapse>
          </li>
        );
      }

      return (
        <li className={activeRoute(prop.layout + prop.path)} key={key}>
          <NavLink to={prop.layout + prop.path}>
            {prop.icon ? (
              <>
                <i className={prop.icon} />
                <p>{prop.name}</p>
              </>
            ) : (
              <>
                <span className="sidebar-mini-icon">{prop.mini}</span>
                <span className="sidebar-normal">{prop.name}</span>
              </>
            )}
          </NavLink>
        </li>
      );
    });
  };

  // Remove PerfectScrollbar: native scroll on sidebar-wrapper

  const user = store.getState().user;
  const isMain = store.getState().is_main;

  return (
    <div className="sidebar" data-color={props.bgColor} data-active-color={props.activeColor}>
      <div className="logo" style={{ textAlign: "center" }}>
        <div className="logo-img">
          <Link to="/"><img src={`${base}${store.getState().logo}`} alt="logo" /></Link>
        </div>
      </div>

      <div className="sidebar-wrapper" ref={sidebarRef}>
        <div className="user">
          <div className="photo">
            <img src={user?.image ? base + user.image : avatar} alt="Avatar" />
          </div>
          <div className="info">
            <a
              href="#!"
              onClick={() => setOpenAvatar(!openAvatar)}
              aria-expanded={openAvatar}
            >
              <span>
                {user ? `${user.first_name || ''} ${user.last_name || ''}` : 'Guest User'}
              </span>
            </a>
            <Collapse isOpen={openAvatar}>
              <ul className="nav">
                <li><NavLink to="/admin/profile"><span className="sidebar-normal">My Profile</span></NavLink></li>
              </ul>
            </Collapse>
          </div>
        </div>

        <Nav>
          {createLinks(props.routes)}
          
          <li className={activeRoute('/admin/videos')}>
            <NavLink to="/admin/videos">
              <i className="fa fa-youtube-play" />
              <p>{isMain ? "PTE Secret Strategy" : "Videos"}</p>
              {isMain && <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Videos</p>}
            </NavLink>
          </li>

          {isMain && (
            <li className={activeRoute('/admin/transaction')}>
              <NavLink to="/admin/transaction">
                <i className="fa fa-retweet" />
                <p>Transaction</p>
              </NavLink>
            </li>
          )}

          <li className={activeRoute('/admin/help')}>
            <NavLink to="/admin/help">
              <i className="fa fa-question-circle" />
              <p>Help</p>
            </NavLink>
          </li>
        </Nav>
      </div>
    </div>
  );
}

export default Sidebar;
